import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const Content: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg className={className} x='0px' y='0px' viewBox='0 0 754 95.5'>
        <path
            fill='#222222'
            d='M404,89.3c-6.6,0-13.1,0-19.6,0c0-28.1,0-56.1,0-84.3c5,0,10,0,15.2,0c12.9,16.3,25.9,32.8,39.1,49.4
	c0-16.6,0-33,0-49.4c6.6,0,13.1,0,19.6,0c0,28.1,0,56.1,0,84.3c-5.2,0-10.3,0-15.6,0c-12.8-15.9-25.7-31.8-38.8-48
	C404,57.4,404,73.3,404,89.3z'
        />
        <path
            fill='#222222'
            d='M351.1,89.6c-7.4,0-14.6,0-21.9,0c-5.6-9.1-11.3-18.2-17-27.3c-4.2,0-8.3,0-12.5,0c0,9.1,0,18.2,0,27.3
	c-6.7,0-13.3,0-20,0c0-28.2,0-56.3,0-84.6c0.3-0.2,0.7-0.1,1.1-0.1c12.2,0,24.3,0.1,36.5,0c7.4-0.1,13.6,2.6,18.9,7.6
	c4.7,4.4,7.8,9.8,9.2,16.1c1.1,5,0.4,9.8-1.1,14.6c-2.2,6.6-6.3,11.5-12.3,15C338.3,68.7,344.7,79.1,351.1,89.6z'
        />
        <path
            fill='#222222'
            d='M600.1,5c6.6,0,13.1,0,19.5,0c0.2,0.4,0.1,0.8,0.1,1.2c0,14,0,27.9,0,41.9c0,5.8,1,11.3,3.7,16.4
	c2.5,4.7,6.4,7.6,11.9,8.1c2,0.2,4.1,0.2,6.1-0.3c5.3-1.2,8.7-4.7,11.2-9.3c2.1-3.9,2.6-8.2,2.6-12.5c0.1-14.8,0-29.6,0-44.4
	c0-0.4,0-0.7,0-1.1c6.6,0,13.1,0,19.6,0c0.2,0.3,0.1,0.7,0.1,1.1c0,14.4,0.1,28.8,0,43.2c0,8.3-1.6,16.4-5.6,23.7
	c-5.2,9.3-13.2,14.8-23.7,16.5c-7.4,1.2-14.7,0.9-21.8-1.4c-9.3-3.1-15.5-9.6-19.4-18.4c-3-6.7-4.2-13.8-4.2-21.1
	c0-14.3,0-28.5,0-42.8C600.1,5.5,600.1,5.3,600.1,5z'
        />
        <path
            fill='#222222'
            d='M210.9,4.9c0.4,0,0.8,0,1.1,0c11.8,0,23.6-0.1,35.4,0c7.9,0.1,14.4,3.4,19.3,9.7c3.2,4,5.6,8.4,6.7,13.5
	c1.7,7.9,0.2,15.3-4.1,22.1c-5,7.9-12.2,11.8-21.5,12c-5.5,0.1-11.1,0-16.6,0.1c-0.4,0-0.7-0.1-1.1,0.1c0,9,0,18,0,27.1
	c-6.5,0-12.8,0-19.3,0C210.9,61.4,210.9,33.2,210.9,4.9z'
        />
        <path
            fill='#17BBB4'
            d='M119.5,42.8c1.9-3.2,3.8-6.5,5.7-9.7c5.4-9.2,10.8-18.5,16.2-27.7c0.1-0.2,0.3-0.4,0.5-0.8
	c16.5,28.4,33,56.7,49.5,84.9c-0.2,0.3-0.5,0.2-0.7,0.2c-14.6,0-29.1,0-43.7,0c-0.1,0-0.3,0-0.4,0c-0.9-0.9-1.4-2-2-3.1
	c-4.3-7.4-8.6-14.8-12.9-22.1c-4-6.9-8-13.8-12-20.6c-0.1-0.2-0.3-0.5-0.3-0.7C119.4,42.9,119.4,42.9,119.5,42.8z'
        />
        <path
            fill='#F1C893'
            d='M47.5,89.6c-7,0-14.1,0-21.1,0c-7.4,0-14.9,0-22.3,0c-0.4,0-0.7,0-1.3,0c16.5-28.4,33-56.7,49.5-85
	c0.7,0.5,0.9,1.2,1.2,1.8C57.4,13,61.2,19.6,65,26.2c3.2,5.5,6.4,11.1,9.7,16.6c0.1,0.1,0.1,0.2,0.1,0.3c-0.6,1.5-1.5,2.8-2.3,4.2
	c-6.1,10.4-12.1,20.8-18.2,31.2c-2,3.4-3.9,6.7-5.9,10.1C48.2,89,48,89.4,47.5,89.6z'
        />
        <path
            fill='#222222'
            d='M539.1,5c19.1,0,38.2,0,57.2,0c0,5.7,0,11.3,0,17c-12.5,0-25,0-37.6,0c0,6.1,0,12,0,18c10.3,0,20.6,0,31,0
	c0,5.3,0,10.6,0,16c-10.3,0-20.6,0-31,0c0,11.1,0,22.2,0,33.3c-6.6,0-13,0-19.6,0C539.1,61.2,539.1,33.1,539.1,5z'
        />
        <path
            fill='#222222'
            d='M534.2,5c0,5.6,0,11.2,0,17c-8.4,0-16.9,0-25.4,0c0,22.5,0,44.8,0,67.3c-6.6,0-13.1,0-19.7,0
	c0-22.4,0-44.8,0-67.2c-8.7,0-17.2,0-25.9,0c0-5.7,0-11.3,0-17C486.9,5,510.5,5,534.2,5z'
        />
        <path
            fill='#222222'
            d='M745.5,72.2c0,5.8,0,11.4,0,17c-20.1,0-40.1,0-60.2,0c0-28.1,0-56.1,0-84.3c6.4,0,12.9,0,19.5,0
	c0,22.4,0,44.8,0,67.2C718.4,72.2,731.9,72.2,745.5,72.2z'
        />
        <path
            fill='#EC4642'
            d='M74.7,43c0-0.1,0-0.1,0-0.2c0.8-0.8,1.2-1.9,1.8-2.8c6.7-11.5,13.4-23,20.1-34.5c0.2-0.3,0.3-0.5,0.6-0.9
	c0.2,0.4,0.4,0.6,0.6,0.9c7.1,12.2,14.2,24.3,21.3,36.5c0.2,0.3,0.4,0.5,0.5,0.8c0,0.1,0,0.1,0,0.2c0,0.3-0.2,0.6-0.3,0.9
	c-7.1,12.1-14.1,24.2-21.2,36.3c-0.2,0.4-0.4,0.9-0.9,1.1c-0.5-0.1-0.7-0.5-0.9-0.9c-1.6-2.7-3.1-5.4-4.7-8
	c-2.4-4.2-4.9-8.3-7.3-12.5c-2.6-4.5-5.2-9-7.8-13.5c-0.5-0.8-1-1.6-1.4-2.4C74.9,43.7,74.7,43.4,74.7,43z'
        />
        <path fill='#222222' d='M356,5c6.5,0,13,0,19.5,0c0,28.1,0,56.2,0,84.3c-6.5,0-12.9,0-19.5,0C356,61.2,356,33.1,356,5z' />
        <path
            fill='#16342F'
            d='M97.1,81.2c2.5-4.3,5.1-8.6,7.6-12.9c4.8-8.3,9.6-16.5,14.5-24.8c0.1-0.2,0.2-0.3,0.3-0.5
	c2.3,3.9,4.6,7.8,6.9,11.7c6.7,11.4,13.3,22.9,20,34.4c0.1,0.2,0.2,0.4,0.3,0.6c-0.2,0-0.5,0-0.7,0c-14.4,0-28.9,0-43.3,0
	c-0.2,0-0.5,0-0.7,0c-0.3-0.2-0.6-0.3-0.8-0.7c-0.9-2-2.2-3.7-3.2-5.7c-0.3-0.6-0.9-1.1-1-1.8C97,81.3,97,81.2,97.1,81.2z'
        />
        <path
            fill='#DE392F'
            d='M97.1,81.2c0,0.1,0,0.1,0,0.2c-0.1,0.8-0.6,1.3-0.9,1.9c-1,1.8-2.1,3.6-3.1,5.4c-0.2,0.3-0.4,0.7-0.7,0.9
	c-0.4,0-0.8,0-1.2,0c-14.2,0-28.3,0-42.5,0c-0.4,0-0.8,0-1.2,0c6.4-10.9,12.7-21.8,19.1-32.7c2.7-4.6,5.4-9.3,8.1-13.9
	c3.1,5.3,6.2,10.7,9.3,16c2.3,4,4.7,8,7.1,12c1.8,3,3.5,6.1,5.3,9.2C96.6,80.5,96.8,80.9,97.1,81.2z'
        />
        <path
            fill='#15291A'
            d='M92.3,89.6c1.5-2.8,3.1-5.5,4.8-8.2c1.3,2.1,2.5,4.2,3.8,6.3c0.4,0.6,0.5,1.4,1.1,1.9
	C98.8,89.6,95.6,89.6,92.3,89.6z'
        />
        <path
            fill='#FEFEFE'
            d='M299.3,45.1c-0.1-7.5-0.2-15.1-0.4-22.6c0.4-0.2,0.7-0.1,1.1-0.1c5.1,0,10.2,0,15.2,0c5.1,0,8.6,2.6,9.8,7.6
	c1,4.4,0.6,8.6-2.3,12.3c-1.5,1.9-3.4,3-6,3c-5.4,0-10.9,0-16.3,0C300.1,45.2,299.8,45.3,299.3,45.1z'
        />
        <path
            fill='#FEFEFE'
            d='M230.5,45.1c0-7.7,0-15.4,0-23c0.3-0.3,0.7-0.1,1-0.1c4.8,0,9.6,0,14.3,0c2.4,0,4.2,1.3,5.9,2.8
	c2.2,2,2.8,4.8,3,7.5c0.2,2,0.1,4-0.4,6c-0.9,3.4-2.9,5.8-6.4,6.8c-0.4,0.1-0.8,0.2-1.3,0.2c-5.2,0-10.4,0-15.6,0
	C231,45.2,230.8,45.2,230.5,45.1z'
        />
    </svg>
);

const PrintfulLogo = styled(Content)`
    width: 180px;
    height: 180px;
`;

export default PrintfulLogo;
